import { configureStore } from '@reduxjs/toolkit'
import mediaPlayerReducer from './mediaPlayerSlice'
import bandDiscographyReducer from './bandDiscographySlice'
import navigationReducer from './navigationSlice'
import songActionsReducer from './songActionsSlice'

export default configureStore({
  reducer: {
    mediaPlayer: mediaPlayerReducer,
    bandDiscography: bandDiscographyReducer,
    navigation: navigationReducer,
    songActions: songActionsReducer,
  },
})
